import { services } from '@/mocks/services';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function ServicesSection() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section id="services" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div ref={ref} className={`text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            On vous accompagne bien plus qu'à l'achat
          </h2>
          <p className="text-foreground-600 mt-3 max-w-xl mx-auto text-sm md:text-base">
            Chaque véhicule est préparé avec soin pour vous garantir une tranquillité totale.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-8 md:mt-12">
          {services.map((service, idx) => (
            <div
              key={service.title}
              className={`group bg-white rounded-lg p-5 md:p-6 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${service.icon} w-6 h-6 flex items-center justify-center text-primary-600 text-xl`} />
              </div>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900">
                {service.title}
              </h3>
              <p className="text-foreground-600 text-sm mt-2 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <a
            href="tel:+262692505551"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-white font-label font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
            Nous appeler
          </a>
        </div>
      </div>
    </section>
  );
}